import { defineComponent as a, computed as r, createElementBlock as c, createCommentVNode as d, openBlock as m, createElementVNode as p } from "vue";
const l = {
  key: 0,
  class: "test-mode-banner"
}, i = /* @__PURE__ */ a({
  __name: "TestModeBanner",
  props: {
    hostname: { default: () => typeof window < "u" ? window.location.hostname : "" }
  },
  setup(e) {
    const o = e, t = r(() => o.hostname.includes("test-"));
    return (s, n) => t.value ? (m(), c("div", l, n[0] || (n[0] = [
      p("span", { class: "test-mode-text" }, "TEST MODE", -1)
    ]))) : d("", !0);
  }
}), u = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [s, n] of o)
    t[s] = n;
  return t;
}, _ = /* @__PURE__ */ u(i, [["__scopeId", "data-v-df67d7f7"]]), B = {
  install(e) {
    e.component("TestModeBanner", _);
  }
};
export {
  _ as TestModeBanner,
  B as default
};
